import { gql } from "@apollo/client";

export const getAVCamount = gql`
  query getAVCamount($plan_id: bigint) {
    plans(where: { id: { _eq: $plan_id } }) {
      total_avc_amount_requested
    }
  }
`;
